import { Box, Grid, Stack, Typography } from "@mui/material";

import { black, divider } from "@/theme/colors";
import { Button } from "@/components/elements/Button";
import { Textarea } from "@/components/elements/Textarea";
import { InnerBox } from "@/components/elements/InnerBox";
import { IconFilePlus } from "@/assets/icons";
import { DocxPreviewWithZoom } from "@/features/talent/components/talent-scan-image/DocxPreviewWithZoom";
import { ImagePreviewWithZoom } from "@/features/talent/components/talent-scan-image/ImagePreviewWithZoom";
import { OfficeFilePreview } from "@/features/talent/components/talent-scan-image/OfficeFilePreview";
import { PdfPreviewWithZoom } from "@/features/talent/components/talent-scan-image/PdfPreviewWithZoom";
import { ScanResultTabs } from "@/features/talent/components/talent-scan-image/ScanResultTabs";
import { ScanResultPanel } from "@/features/talent/components/talent-scan-image/ScanResultPanel";
import { UseScanImageStateReturn } from "@/features/talent/components/talent-scan-image/useScanImageState";

type Props = {
  state: UseScanImageStateReturn;
};

export function ScanResultStep({ state }: Props) {
  const {
    memoWatchField,
    otherNote,
    isShowDropZoneUpdateFile,
    previewFile,
    typePreviewFile,
    onClose,
    createTalent,
  } = state;

  const renderPreview = (item: string | File, index: number) => {
    const fileType = typePreviewFile[index];
    if (fileType === "tiff" && item instanceof File) {
      return <ImagePreviewWithZoom key={index} src={item} type="tiff" height={530} />;
    }
    if (fileType === "image") {
      return <ImagePreviewWithZoom key={index} src={item} type="image" height={530} />;
    }
    if (fileType === "pdf") {
      return <PdfPreviewWithZoom key={index} src={item} width="100%" height={530} />;
    }
    if (fileType === "docx" && item instanceof File) {
      return <DocxPreviewWithZoom key={index} src={item} width="100%" height={530} />;
    }
    if (fileType === "office" && item instanceof File) {
      return <OfficeFilePreview key={index} filename={item.name} height={530} />;
    }
    return null;
  };

  return (
    <>
      <Grid container padding={3} spacing={2} height="100%">
        <Grid item xs={6}>
          <InnerBox
            showDivider={false}
            borderColor={black[95]}
            padding={2}
            sx={{
              height: "calc(85vh - 180px)",
              maxHeight: "611px",
              overflow: "auto",
            }}
          >
            {memoWatchField && (
              <>
                <Typography variant="sub16Bold">人材情報や面談などのメモ</Typography>
                <Box sx={{ marginTop: "16px", marginBottom: "48px" }}>
                  <Textarea value={otherNote} disabled />
                </Box>
              </>
            )}
            {isShowDropZoneUpdateFile && (
              <>
                <Typography variant="sub16Bold">読み取った書類プレビュー</Typography>
                {previewFile.map((item, index) => renderPreview(item, index))}
              </>
            )}
          </InnerBox>
        </Grid>
        <Grid item xs={6}>
          <InnerBox
            showDivider={false}
            borderColor={black[95]}
            padding={2}
            sx={{
              height: "calc(85vh - 180px)",
              maxHeight: "611px",
              overflow: "auto",
            }}
          >
            <ScanResultTabs state={state} />
            <ScanResultPanel state={state} />
          </InnerBox>
        </Grid>
      </Grid>
      <Box maxHeight={69}>
        <hr color={divider.high} />
        <Stack direction="row" gap="16px" justifyContent="space-between" p="16px 32px">
          <Button size="sm" variant="ghost" onClick={onClose}>
            キャンセル
          </Button>
          <Button size="sm" variant="primary" onClick={createTalent} startIcon={<IconFilePlus />}>
            上記内容で編集画面に反映
          </Button>
        </Stack>
      </Box>
    </>
  );
}
